export class Zona {
    id: number;
    nombre: string;
    idEmpresa: number;
    userCreation: string;
    dateCreation?: string;
    userLastUpdate?: string;
    dateLastUpdate?: string;
}
